import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Divider,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import WarningIcon from "@mui/icons-material/Warning";
import CloseIcon from "@mui/icons-material/Close";
import TextView from "../TextView";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  ".MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
  ".MuiPaper-root": {
    padding: "15px 8px",
    border: "1px solid #E1E1E1",
    borderRadius: 8,
  },
}));

const SaveChangesModal = ({
  isOpen,
  title,
  subtitle,
  onLeave,
  onClose,
  onSave,
}) => {
  return (
    <StyledDialog
      open={isOpen}
      onClose={onClose}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{
        zIndex: 6522299,
      }}
    >
      <DialogTitle>
        <TextView variant="title">
          <WarningIcon sx={{ color: "#F5CC3B" }} />
          <span style={{ marginLeft: "10px" }}>{title}</span>
        </TextView>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 12,
            top: 20,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Divider sx={{ marginBottom: "20px", color: "#E1E1E1" }} />
        <TextView variant="subtitle">{subtitle}</TextView>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button
            sx={{
              color: "#495057",
              textTransform: "capitalize",
              fontSize: "16px",
              fontWeight: "500",
            }}
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            sx={{
              color: "#495057",
              textTransform: "capitalize",
              fontSize: "16px",
              fontWeight: "500",
              border: "1px solid #E1E1E1",
            }}
            onClick={onLeave}
          >
            Leave Without Saving
          </Button>

          <Button
            onClick={onSave}
            sx={{
              color: "white",
              textTransform: "capitalize",
              fontSize: "16px",
              fontWeight: "500",
              background: "#9B5AF8",

              "&:hover": {
                background: "#9B5AF885",
              },
            }}
          >
            Save Changes
          </Button>
        </Box>
      </DialogActions>
    </StyledDialog>
  );
};

export default SaveChangesModal;
